/**
 * ActionProvider that executes possible actions after an event occurs.
 */
(function () {
    'use strict';

    angular
        .module('SodCustomAction')
        .factory('Action', ActionFactory);

    function ActionFactory(Request, lodash, Path, $window, $timeout,
                           ModalService, DatasourceRegistry, NotificationService, MasterLayoutService, $http,
                           ButtonRegistry, $injector, FormBuilderService, ActionCommon, ListFilterStateFactory) {
        var controller = {};
        return {
            run: function (event, actions, content, eventData, scope) {
                controller[event] = new ctrl(event, actions, content, eventData, scope);
                controller[event].run();
            },
            closeDialogActions: function () {
                return {
                    dialog_close_quick: {}
                };
            },
            reverseMapField: function (schema, rules) {
                var result = {};
                for (var key in rules) {
                    result[schema[key]] = rules[key];
                }
                return result;
            }
        };

        function ctrl(event, actions, content, eventData, scope) {
            return {
                run: function () {
                    // need a control to allow step by step execution of actions?
                    angular.forEach(actions, function (action, actionType) {
                        if (lodash.has(action, 'dialogTemplate')) {
                            this['confirmation'](action, actionType);
                        } else {
                            this[actionType](action);
                        }
                    }, this);
                },
                notification: function (data) {
                    NotificationService.set(data);
                },
                redirect: function (data) {
                    var sub_id = '';
                    if (data.sub_id) {
                        sub_id = lodash.get(eventData.model, data.sub_id, '');
                    }
                    var _path = Path.replace(data.destination, sub_id);
                    Path.redirect(_path);
                },
                download: function (data) {
                    var _path = data.route;
                    window.location.href = _path;
                },
                redirect_external: function (data) {

                    if (data.history_path) {
                        var _path = Path.replace(data.history_path);
                        window.history.pushState({}, '', _path);
                    }

                    $window.location.href = data.destination;
                },
                back_to_previous: function () {
                    $window.history.back();
                },
                grid_item_redirect: function (data) {
                    // get the grid object from sender wrapper
                    var grid = eventData.target.parents('.k-grid').data('kendoGrid');

                    // get the selected data
                    var dataItem = grid.dataItem(eventData.target.parents('tr'));

                    // generate the path
                    //var _path = Path.replace(data.destination, lodash.get(dataItem, 'schema.key', dataItem['id']));
                    var _path = decodeURI(data.route).replace(new RegExp('<id>', 'g'), dataItem.id);
                    // redirect
                    Path.redirect(_path);
                },

                grid_item_download: function (data) {
                    // get the grid object from sender wrapper
                    var grid = eventData.target.parents('.k-grid').data('kendoGrid');

                    // get the selected data
                    var dataItem = grid.dataItem(eventData.target.parents('tr'));

                    // generate the path
                    //var _path = Path.replace(data.destination, lodash.get(dataItem, 'schema.key', dataItem['id']));
                    var _path = decodeURI(data.route).replace(new RegExp('<id>', 'g'), dataItem.id);
                    window.location.href = _path;
                    // // redirect
                    // var anchor = angular.element('<a/>');
                    // anchor.attr({
                    //     href: _path,
                    //     target: '_self',
                    //     download: dataItem.candidate_profile_version_id + '.pdf'
                    // })[0].click();

                },
                grid_item_api_call: function (data) {
                    var grid = eventData.target.parents('.k-grid').data('kendoGrid');
                    var dataItem = grid.dataItem(eventData.target.parents('tr'));
                    var _path = decodeURI(data.route).replace(new RegExp('<id>', 'g'), dataItem.id);
                    var method = lodash.get(data, 'method', 'post');
                    var model = lodash.get(data, 'model', angular.copy(dataItem));
                    if (data.schema) {
                        model = this.set_schema(model, data.schema);
                    }

                    Request.run(method, _path, event, eventData, model);
                },

                grid_selected_api_call: function (data) {
                    // get the current listFilter object and get the model
                    var listfilterService = ListFilterStateFactory.get(lodash.get(data, 'identifier', null));
                    var model = listfilterService.getSelectedModel();
                    var path = data.datasource.url;
                    var method = lodash.get(data.datasource, 'method', 'get');
                    // get the datasource/route
                    // send request
                    Request.run(method, path, event, eventData, model);
                },

                grid_mass_dialog: function (data) {
                    var listfilterService = ListFilterStateFactory.get(lodash.get(data, 'identifier', null));
                    var model = listfilterService.getSelectedModel();
                    ActionCommon.show_dialog(data, model);
                },

                grid_row_dialog: function (data) {
                    var grid = eventData.target.parents('.k-grid').data('kendoGrid');
                    var dataItem = grid.dataItem(eventData.target.parents('tr')).toJSON();

                    ActionCommon.show_dialog(data, dataItem);
                },

                grid_clear_selected: function (data) {
                    var listfilterService = ListFilterStateFactory.get(lodash.get(data, 'identifier', null));
                    listfilterService.clearSelected();
                },
                form_submit_selected: function (data) {
                    var listfilterService = ListFilterStateFactory.get(lodash.get(data, 'identifier', null));
                    eventData.selected = listfilterService.getSelectedModel();
                    this.form_submit(data);
                },

                form_submit: function (data) {
                    var _path = Path.replace(data.route);
                    var model = eventData.model || content.model;

                    if (data.form_name.length > 0) {
                        var fbService = FormBuilderService.get(data.form_name);
                        model = fbService.model;
                        eventData.fbService = fbService;
                    }

                    if (data.schema) {
                        model = this.set_schema(model, data.schema);
                    }
                    Request.run(data.method, _path, event, eventData, model);
                },
                dialog_submit: function (data) {
                    var _path = Path.replace(data.destination);
                    Request.run(data.method, _path, event, eventData, content.dialogModel);
                },
                api_call: function (data) {

                    var _path = Path.replace(data.route);
                    var method = lodash.get(data, 'method', 'get');
                    var model = lodash.get(eventData, 'model', content.model);
                    if (data.model) {
                        model = lodash.merge({}, model, data.model);
                    }
                    if (data.schema) {
                        model = this.set_schema(model, data.schema);
                    }

                    Request.run(method, _path, event, eventData, model);
                },

                panel_api_call: function (data) {
                    var _path = Path.replace(data.route);
                    var method = lodash.get(data, 'method', 'get');
                    var PanelService = $injector.get('PanelRegistry');
                    var model = PanelService.get(data.panel_id, data.data_path);
                    Request.run(method, _path, event, eventData, model);
                },

                dialog_open: function (data) {
                    //var that = this;

                    if (lodash.has(data.dialogOptions, 'appendSelectedModel')) {
                        var modelKey = lodash.get(data.dialogOptions, 'appendSelectedModel.key', 'dialogOptions.form.model.selected');
                        var listfilterService = ListFilterStateFactory.get(lodash.get(data, 'identifier', null));
                        var selected = listfilterService.getSelectedModel();
                        lodash.set(data, modelKey, selected);
                    }
                    //
                    ActionCommon.show_dialog(data);
                },

                validate: function (data) {
                    angular.element('label').removeClass('error');
                    angular.element('.error-message').remove();
                    content.validation = data;
                    this.scroll_to_error(data);
                    //ElementRegistry.setValidation(data);
                },

                set_schema: function (data, rules) {
                    var object = {};
                    for (var key in rules) {
                        lodash.set(object, key, angular.copy(lodash.get(data, rules[key], '')));
                    }
                    return object;
                },
                scroll_to_error: function (data) {
                    $timeout(function () {
                        if (data.summary) {
                            $('html,body').animate({
                                scrollTop: angular.element('.callout').offset().top - 50
                            }, 300);
                        } else {
                            $('html,body').animate({
                                scrollTop: angular.element('.error').offset().top - 50
                            }, 300);
                        }

                    });
                },
                set_model: function (data) {
                    content.model = angular.merge(data.clearModel, data.model);
                    if (lodash.has(content.model, 'hid_ref_form')) {
                        var formIdentifier = content.model.hid_ref_form;
                        var FormBuilderService = $injector.get('FormBuilderService');
                        var fbService = FormBuilderService.get(formIdentifier);
                        fbService.model = content.model;
                        lodash.set(fbService, 'fbData.model', content.model);
                    }
                },
                dom_manipulation: function (data) {
                    switch (data.type) {
                        case "add_class":
                            angular.element(data.dom).addClass(data.cssClass);
                            break;
                        case "remove_class":
                            angular.element(data.dom).removeClass(data.cssClass);
                            break;
                    }

                },
                update_panel_data: function (data) {
                    var PanelRegistry = $injector.get('PanelRegistry');
                    PanelRegistry.refresh(data.panel_id, data.panel);
                },
                confirmation: function (data, actionType) {
                    var that = this;
                    ModalService.showModal({
                        template: data.dialogTemplate,
                        controller: 'ConfirmationDialogCtrl',
                        controllerAs: 'vm',
                        appendElement: angular.element('.modal-wrapper'),
                        inputs: {
                            dialogOptions: data.dialogOptions
                        }
                    }).then(function (modal) {
                        modal.element.show();
                        modal.close.then(function (result) {
                            if (result) {
                                that[actionType](data);
                            } else {
                                ButtonRegistry.clearAllLoading();
                            }
                        });
                    });
                },

                datasource_refresh: function (data) {
                    if (data.datasource_name == 'ListFilterService') {
                        var listfilterService = ListFilterStateFactory.get(lodash.get(data, 'identifier', null));
                        listfilterService.refreshGrid();
                    } else {
                        DatasourceRegistry.refresh(data.datasource_name);
                    }
                },
                datasource_refresh_all: function () {
                    DatasourceRegistry.refreshAll();
                },
                //update_tabstrip: function(data) {
                //    var datasource = DatasourceRegistry.get(data.name);
                //    var datasource = DatasourceRegistry.get(data.name);
                //    var index = lodash.findIndex(datasource.view(), function(item) a
                //        return item.title == data.title;
                //    });
                //    angular.element('.' + data.name).data('kendoTabStrip').select(index);
                //},
                //select_tabstrip: function(data) {
                //    var datasource = DatasourceRegistry.get(eventData.targetScope.description);
                //    var tab = lodash.find(datasource.data(), function(item) { return item.title == eventData.event.item.textContent });
                //    Path.selectTabstrip(tab.title.toLowerCase());
                //}

                // Todo: Some actions that can be created
                // 1. Loading overlay to prevent users from clicking on more button
                // 2. Remove the loading overlay
                // 3. Form validation: showing of error messages upon exception - Pending validation endpoint from backend
                // 4
                structure_refresh: function () {
                    //todo please refresh the structure
                    var currentPath = Path.getPathInfo();
                    scope.mainService.getStructure(currentPath);
                },
                masterpage_data_refresh: function () {
                    var navUrl = Path.getMasterLayoutDataPath();
                    $http.get(navUrl).then(function (res) {
                        if (res.data.success) {
                            MasterLayoutService.set(res.data.structure);
                        }
                    }, function () {
                    });
                },
                trigger_async_panel_event: function (data) {
                    const PanelManager = $injector.get('PanelManager');
                    const panel = PanelManager.getByPanelContentId(data.panel_content_id);
                    panel.emitEvent(data.event_name, data.event_data);
                },

                show_floating_notification: ActionCommon.show_floating_notifier,
                show_static_notification: ActionCommon.show_static_notifier
            };
        }
    }
})();
